import { Link } from "react-router-dom";
import { featuredArticles } from "@/mocks/articles";
import SectionHeading from "@/components/feature/SectionHeading";

export default function HotList() {
  const [first, second, ...rest] = featuredArticles;

  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        kicker="本日热点"
        title="热点情报速递"
        desc="热门游戏漫画化与联动活动的最新动态，为你整理关键信息。"
        to="/youxi-zixun"
        linkText="查看更多资讯"
      />
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
        <Link
          to={`/article/${first.slug}`}
          className="group relative overflow-hidden rounded-lg lg:col-span-2"
        >
          <img
            src={first.cover}
            alt={first.title}
            title={`${first.title} - 可游漫画网`}
            className="h-64 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105 md:h-96"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/50 to-transparent" />
          <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
            <span className="manga-clip mb-3 inline-block bg-accent-500 px-2.5 py-1 text-xs font-bold text-foreground-950">
              {first.tag}
            </span>
            <h3 className="font-heading text-xl leading-snug text-background-50 md:text-2xl">
              {first.title}
            </h3>
            <p className="mt-2 hidden text-sm text-background-300 md:line-clamp-2">{first.excerpt}</p>
            <div className="mt-3 flex items-center gap-4 text-xs text-background-400">
              <span className="flex items-center gap-1"><i className="ri-calendar-line" />{first.date}</span>
              <span className="flex items-center gap-1"><i className="ri-eye-line" />{first.views.toLocaleString()}</span>
            </div>
          </div>
        </Link>

        <div className="flex flex-col gap-4">
          <Link
            to={`/article/${second.slug}`}
            className="group relative overflow-hidden rounded-lg"
          >
            <img
              src={second.cover}
              alt={second.title}
              title={`${second.title} - 可游漫画网`}
              className="h-36 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105 md:h-44"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-4">
              <span className="mb-1 inline-block bg-accent-500 px-2 py-0.5 text-xs font-bold text-foreground-950">{second.tag}</span>
              <h4 className="font-heading text-base leading-snug text-background-50">{second.title}</h4>
            </div>
          </Link>
          {rest.slice(0, 1).map((a) => (
            <Link
              key={a.slug}
              to={`/article/${a.slug}`}
              className="group relative overflow-hidden rounded-lg"
            >
              <img
                src={a.cover}
                alt={a.title}
                title={`${a.title} - 可游漫画网`}
                className="h-36 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105 md:h-44"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-4">
                <span className="mb-1 inline-block bg-accent-500 px-2 py-0.5 text-xs font-bold text-foreground-950">{a.tag}</span>
                <h4 className="font-heading text-base leading-snug text-background-50">{a.title}</h4>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}